import React, { useState } from 'react';
import { StyledForm, SubscribeLabel } from './Style';

const SubscribeForm = ({
  dataPosition,
  formType,
  inlineMarketingForm,
  label = 'Get our weekly newsletter',
  onSuccess,
  formClassNames,
  ...otherProps
}) => {
  const [hide, setHide] = useState(false);

  return (
    <>
      {label && <SubscribeLabel className="subscribe-form--label">{label}</SubscribeLabel>}
      <StyledForm
        className={formClassNames}
        dataPosition={dataPosition}
        formType={formType}
        title=""
        inlineMarketingForm={hide ? null : inlineMarketingForm}
        containerPadding="0"
        backgroundColor="transparent"
        showPrivacy={false}
        onSuccess={() => {
          if (!otherProps.notificationSnack) {
            setHide(true);
          }

          onSuccess && onSuccess();
        }}
        {...otherProps}
      />
    </>
  );
};

export default SubscribeForm;
